import { meetsAxiosProtected as axios } from '../httpInstance/http'

export const getNotes = roomName => {
    return axios.get(`/${roomName}/note`)
}
